export default __webpack_public_path__ + "static/media/caret-up.90bab0ca.svg";